import * as React from 'react';
import { DocumentStatusTypes } from '../../Document/_stores/DocumentStore';
import { Trans } from "react-i18next";
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import { ButtonBase } from '@mui/material'

export type Props = {
	onSave?: Function
	setStatus?: Function
	orderProduct?: (id:string, productType:string) => void
	status?: string
	savedId?: string
	store?: any
}

type State = {
	orderNowClicked: boolean
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class OrderNowButton extends AwareComponent<Props, State> {
	state = {
		orderNowClicked: false
	} as State

	private onSave() {
		this.setState({
			orderNowClicked: true
		});

		let formData = new FormData();
		formData.append('store', JSON.stringify(this.props.store.toJS()));

		this.props.onSave(formData);
	}

	componentDidUpdate(prevProps:Props, prevState:State){
		let statusChanged = this.propChanged(prevProps, 'status');
		if (this.state.orderNowClicked && statusChanged && this.props.status == DocumentStatusTypes.Saved) {
			this.props.setStatus(DocumentStatusTypes.Edit);
			this.props.orderProduct(this.props.savedId, 'pattern');

			this.setState({
				orderNowClicked: false
			});
		}
	}

	render = () => <>
		<ButtonBase>
			<div onClick={this.onSave.bind(this)} className="action-buttons-icon blue-bg">
				<img src="static/img/icons/cart-white-icon.svg" alt="" width="25" height="25" />
				<div className="text">ORDER</div>
			</div>
		</ButtonBase>
	</>
}